import { Component, Input } from '@angular/core';

@Component({
  selector: 'kt-charge-analysis',
  templateUrl: './charge-analysis.component.html',
  styleUrls: ['./charge-analysis.component.scss'],
})
export class ChargeAnalysisComponent {
  @Input() data: any;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {}
}
